module.exports = __webpack_public_path__ + "static/media/turkey.6089f063.svg";